export enum DocumentStatus {
  "LOADING" = -1,
  "LOADED" = 0,
  "LOAD_FAILED" = 1,
  "UPLOADING" = 20,
  "PARSING" = 30,
  "RELOADING" = 40,
}
